export default __webpack_public_path__ + "static/diners-bb67a6633eee68daa0c6082d358c6f2f.svg";